<template>
    <div class="pagination">
        <ul class="pagination--list u-reset">
            <li class="pagination--item" v-if="isPrevButtonEnabled">
                <simple-btn class="pagination--button"

                        :facets="['pagination', 'has-grid']"
                        @click="onClick($event, current - 1)">
                    <ui-icon size="large" symbol="chevron-left"/>
                </simple-btn>
            </li>
            <li
                    class="pagination--item"
                    v-for="page in pageRange"
                    :key="page">
                <simple-btn class="pagination--button"
                        :disabled="page === current"
                        :facets="['pagination']"
                        @click="onClick($event, page)">
                    {{ page }}
                </simple-btn>
            </li>
            <li class="pagination--item" v-if="isNextButtonEnabled">
                <simple-btn class="pagination--button"
                        :facets="['pagination', 'has-grid']"
                        @click="onClick($event, current + 1)">
                    <ui-icon size="large" symbol="chevron-right"/>
                </simple-btn>
            </li>
        </ul>
    </div>
</template>

<script>
    import { range } from 'lodash/fp';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import SimpleBtn from '../buttons/simple-btn/simple-btn';

    export default {
        components: { SimpleBtn, UiIcon },
        props: {
            current: {
                type: Number,
                required: true,
            },
            maxAmount: {
                type: Number,
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
        },
        computed: {
            pageRange() {
                const halfMaxAmount = Math.floor(this.maxAmount / 2);
                // tail that we need to add if we are at beginning of the pagination
                const rightPad = halfMaxAmount > this.current ? halfMaxAmount - this.current : 0;

                // add below and above the current page
                return range(this.current - halfMaxAmount, this.current + halfMaxAmount + rightPad)
                    // remove negative values and values bigger than the total pages amount
                    .filter(p => p > 0 && p <= this.total);
            },
            isPrevButtonEnabled() {
                return this.current > 1;
            },
            isNextButtonEnabled() {
                return this.current < this.total;
            },
        },
        methods: {
            onClick(event, page) {
                this.$emit('page-change', event, page);
            },
        },
    };
</script>
